import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-panel" }
const _hoisted_2 = { class: "custom-operation" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "custom-operation__title" }, "自定义界面", -1)
const _hoisted_4 = { class: "custom-operation__confirm" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "custom-divider" }, null, -1)

import { ref } from 'vue'
import { NSpace } from 'naive-ui'
// import Icon from '@teams/common/components/icon'
import PcCustom from './customContent/pcCustom.vue'
import H5Custom from './customContent/h5Custom.vue'
import useViewConfig from '@/hooks/useViewConfig'
import { useH5Preview } from '@/views/home/preview'
import usePreference from '@teams/common/hooks/usePreference'
import useAppDialog from '../appDialog/useAppDialog'
import commonConfirmDialog from '@/components/dialog/commonConfirmDialog.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const appDialog = useAppDialog()
const preference = usePreference()
// 收起面板
const { closeCustomPanel, setFloatBall } = useViewConfig()
const closePanel = () => {
  closeCustomPanel()
  setFloatBall(true)
}
// 切换端 true->H5/false->PC
const h5Preview = useH5Preview()
const clientFlag = ref(false || h5Preview.isShow)
// 暂时隐藏
// const clientPC = () => {
//   h5Preview.hide()
//   clientFlag.value = h5Preview.isShow
// }
// 暂时隐藏
// const clientH5 = () => {
//   h5Preview.show()
//   clientFlag.value = h5Preview.isShow
// }

// 确定取消
const cancel = () => {
  preference.cancel({
    onCancel: ({ next, hasUnsaved }) => {
      if (hasUnsaved()) {
        appDialog.show({
          component: commonConfirmDialog,
          title: '放弃更改',
          componentProps: {
            content: '界面效果已产生更改，是否放弃这些更改？',
            confirmButtonText: '放弃',
            onOK: () => {
              closePanel()
              setFloatBall(false)
              next()
            }
          },
          footer: false,
          size: 'small'
        })
      } else {
        closePanel()
        setFloatBall(false)
        next()
      }
    }
  })
}
const confirm = async () => {
  await preference.save()
  // 发布完毕后关闭面板
  closePanel()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(NSpace), {
        class: "custom-operation__space",
        size: 20
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(NSpace), null, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "custom-operation__confirm__cancel",
              onClick: cancel
            }, " 取消 "),
            _createElementVNode("div", {
              class: "custom-operation__confirm__push",
              onClick: confirm
            }, " 确定 ")
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_5,
    (!clientFlag.value)
      ? (_openBlock(), _createBlock(PcCustom, { key: 0 }))
      : _createCommentVNode("", true),
    (clientFlag.value)
      ? (_openBlock(), _createBlock(H5Custom, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})